<template>
  <a :href="post.url"
    target="blank"
    rel="noopener noreferrer"
    class="card card-post"
    :title="post.title">
    <img
      v-lazy="post.image"
      :alt="post.title"
      :title="post.title"
      loading="lazy"
      class="post-image">
    <div class="post-content">
      <h4 class="post-title">{{ post.title }}</h4>
      <p class="post-published">
        <i class="far fa-clock"></i>
        {{ timeago(post.published) }}
      </p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'CardNews',

  props: {
    post: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  methods: {
    timeago(string) {
      if (!string) return '';
      return this.$day().to(this.$day(string));
    },
  },
};
</script>

<style lang="scss">
  .card-post {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: 1rem;
    background-color: #fff;
    cursor: pointer;
    text-decoration: none;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0,0,0,0.025);

    .post-image {
      height: 7rem;
      width: 7rem;
      object-fit: cover;
    }

    .post-content {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: space-between;
      margin: 0.75rem 1rem;
      width: 100%;
      height: 5.5rem;
      overflow: hidden;
      font-size: 0.875rem;
      color: #222;

      .post-title {
        margin-bottom: 0.25rem;
        font-size: 14px;
        font-weight: 600;
        color: #222;
      }

      .post-published {
        margin-bottom: 0;
        font-size: 0.75rem;
        color: $grey-medium;

        svg {
          margin-right: 0.25rem;
          color: $color-secondary;
        }
      }
    }
  }
</style>
